import { useLocation } from "react-router";

import { pageTitleForEstimateTrackerPath, EstimateTrackerPath } from "./EstimateTrackerRoutes";

export interface EstimateTrackerPageProps {
  children?: React.ReactNode;
}

export const EstimateTrackerPage: React.FC<EstimateTrackerPageProps> = ({ children }) => {
  // Extract the tracker path from the current URL path
  const location = useLocation();
  const trackerPath = /estimate\/[^/]+\/([^/]+)/.exec(location.pathname)?.[1];

  // Get the page title based on the tracker path
  const pageTitle = trackerPath ? pageTitleForEstimateTrackerPath[trackerPath as EstimateTrackerPath] : null;

  return (
    <>
      {/*
      TODO: Set the page title here once we update to React v19
      see: https://react.dev/blog/2024/12/05/react-19#support-for-metadata-tags
      <title>{pageTitle}</title>
      */}
      <div className="d-flex flex-column h-100">
        <div className="col-auto">
          <h2 className="mb-3">{pageTitle}</h2>
        </div>
        {children}
      </div>
    </>
  );
};
